<form class="w-100 h-100 form" [formGroup]="benefitPdfForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Insertar PDF de beneficio</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img" [src]="fileImg64" alt="img-footer-logo" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-footer-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image' : '' }} </mat-icon>
            <span class="my-2" *ngIf="!benefitPdfForm.value.pdf">
              Subir pdf
            </span>
            <span class="my-2" *ngIf="benefitPdfForm.value.pdf">{{benefitPdfForm.value.pdf}}</span>
          </label>
          <input id="file-upload-footer-logo" type="file" accept="application/pdf" (change)="getBase64($event)"/>
        </div>
        <div id="display-pdf"></div>
      </div>
    </div>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="benefitPdfForm.invalid">
      Guardar
    </button>
  </div>
</form>
